import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

// const transform = 'matrix(1,0,0,1,0.454388,-0.436976)';

const d1 =
  'M4.691,0.874L4.691,2.655L0,2.655L0,4.412L14.091,4.412L14.091,2.655L9.41,2.655L9.41,0.874L4.691,0.874Z';
const d2 =
  'M7.511,12.359L9.397,12.359L9.397,7.94L7.511,7.94L7.511,12.359ZM4.706,12.356L6.567,12.356L6.567,7.948L4.706,7.948L4.706,12.356ZM1.875,5.294L1.875,13.613C1.875,14.378 2.536,15 3.348,15L10.741,15C11.553,15 12.214,14.378 12.214,13.613L12.214,5.294L1.875,5.294Z';

const Delete: React.FC<IconProps> = ({
  className = '',
  clipRule = 'evenodd',
  fill = colors.blueGrey,
  fillRule = 'evenodd',
  strokeLinejoin = 'round',
  strokeMiterlimit = '2',
  viewBox = '0 0 15 15',
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      clipRule={clipRule}
      fill={fill}
      fillRule={fillRule}
      strokeLinejoin={strokeLinejoin}
      strokeMiterlimit={strokeMiterlimit}
      viewBox={viewBox}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path d={d1} />
      <Elements.Path d={d2} />
    </Elements.Svg>
  );
};

export default Delete;
